// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"242":"94c45217","372":"080f5d32","453":"46d18d9d","732":"0a091e5f","977":"fb2c55fa"}[chunkId] + ".chunk.js";
};